


// Class Definition
var selectedColor="#fff";
var selectedText="";
var selectedVel=200;
var divTextBox;
var divText;
var highlightTextControl;
var left;
var init;
var max;
var fullscreen = false;
var orientationInfo=0;
var HighlightTextController = function() {
    
    var highlightText = function() {

       
        highlightTextControl = setInterval(function() {
            divText.style.left = left + "px";
            left = left-30;
            if(left <= max){
                left = init;
            }
            //document.getElementById("debug").innerHTML = left + '--' + max;
        }, selectedVel);
       

    }

    var selectColor = function(){
        document.getElementById("selectColor").addEventListener("input", function(event){
            divText.style.color = event.target.value;
            selectedColor = event.target.value; 
        }, false);
    };

    var selectText = function(){
        document.getElementById("selectText").addEventListener("input", function(event){
            selectedText = document.getElementById("selectText").value;
            setup();
        }, false);
    };


    var selectVel = function(){
        document.getElementById("selectVel").addEventListener("input", function(event){
            selectedVel = (350 - event.target.value);
            setup();
        }, false);
    };

    var eventFullScreen = function(){
        document.getElementById("fullScreenEvent").addEventListener("click", function(event){
            
            document.getElementById("divTextBox").requestFullscreen();
            setTimeout(() => {
                setup();
            }, 100);
        }, false);

        window.addEventListener("orientationchange", function() {
            orientationInfo = window.orientation;
            setTimeout(() => {
                setup();
            }, 100);
        }, false);

        document.getElementById("divTextBox").addEventListener('fullscreenchange', (event) => {
          
            if (document.fullscreenElement) {
                document.getElementById("divTextBox").classList.add("fullscreen");
                
            } else {
                document.getElementById("divTextBox").classList.remove("fullscreen");
                setTimeout(() => {
                    setup();
                }, 100);
            }
            
        }, false);
       
    };

    
    var setup = function(){
        divText = document.getElementById("divText");
        selectedText = document.getElementById("selectText").value;
        divText.innerHTML = selectedText;
        divTextBox = document.getElementById("divTextBox");
        divTextGrid = document.getElementById("divTextGrid");

        left = divText.offsetWidth;
        init = divText.offsetWidth;
        max = divText.scrollWidth - (divText.scrollWidth * 2);
        
        clearInterval(highlightTextControl);
        highlightText();

        /*
        var obj = {
            selectedText: selectedText,
            selectedColor: selectedColor,
            selectedVel: selectedVel
        };
        var encoded = btoa(JSON.stringify(obj))

        document.getElementById("linkFullScreen").href= 'letreiro-digital/' + encoded;
        */
    };


    var divJail = function(){
        h = divTextBox.offsetHeight;
        w = divTextBox.offsetWidth;
        t = (h + w) * 5 ;
        
        for (let index = 0; index < t; index++) {
            div = document.createElement("div");
            divTextGrid.append(div);
        }
    };

    
    

    return {
        init: function() {
            setup();
            selectText();
            selectColor();
            selectVel();
            divJail();
            eventFullScreen();
            
            
            
        }
    };
}();

// Class Initialization
$(function(){
    HighlightTextController.init();
    
});